var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuperadminDashobardItemInsurancesTotalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Wallet",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.822,
    height: 43.532,
    viewBox: "0 0 45.822 43.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Wallet-2",
    "data-name": "Wallet",
    d: "M13.317,43.532A13.485,13.485,0,0,1,0,29.914v-16.3A13.485,13.485,0,0,1,13.317,0H32.506A13.485,13.485,0,0,1,45.822,13.618v16.3A13.485,13.485,0,0,1,32.506,43.532ZM3.33,13.618v16.3a10.112,10.112,0,0,0,9.986,10.211H32.506a10.112,10.112,0,0,0,9.986-10.211v-.633H35.168a7.82,7.82,0,0,1-.417-15.616l.419-.012h7.322v-.035A10.112,10.112,0,0,0,32.506,3.406H13.317A10.112,10.112,0,0,0,3.33,13.618Zm27.528,7.848a4.372,4.372,0,0,0,3.976,4.4l.336.012h7.322V17.059H35.17A4.361,4.361,0,0,0,30.858,21.466Zm4.635,1.565a1.707,1.707,0,0,1-.225-3.392l.225-.014h.693a1.706,1.706,0,0,1,.227,3.39l-.227.016ZM11.735,13.71a1.706,1.706,0,0,1-.225-3.39l.225-.016H23.722a1.706,1.706,0,0,1,.227,3.39l-.227.016Z",
    fill: "#199b8b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperadminDashobardItemInsurancesTotalIcon);
export default __webpack_public_path__ + "static/media/superadmin-dashobard-item-insurances-total-icon.34c6dee92826ff8b4362d0ad4d5e7e1e.svg";
export { ForwardRef as ReactComponent };